import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import "../style.css";
import EmployeesService from "../../../../../services/HRM/EmployeesService";
import { Translate } from "../../../../Enums/Tranlate";
import DepartmentService from "../../../../../services/Company/DepartmentService";
import BranchesService from "../../../../../services/Company/BranchesService";
import ScrollPagination from "../../../../common/ScrollPagination";
import Loader from "../../../../common/Loader";
import NoData from "../../../../common/NoData";
import Pagination from "../../../../common/Pagination/Pagination";
import CardItem from "./CardItem";
import { Link } from "react-router-dom";

const ActiveEmployees = () => {
	const [formData, setFormData] = useState({
		search: "",
		department: "",
		type: "",
		branch: null,
		mainBranch: null,
	});
	const [filterParams, setFilterParams] = useState({});
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const employeesService = new EmployeesService();
	const branchesService = new BranchesService();

	useEffect(() => {
		let filter = {};
		if (!!formData?.search) filter["search"] = formData?.search;
		if (!!formData?.department)
			filter["departmentId"] = formData?.department?.value;
		if (!!formData?.type) filter["type"] = formData?.type?.value;
		if (!!formData?.branch) filter["branchId"] = formData?.branch?.value;
		if (
			formData?.mainBranch &&
			formData?.mainBranch?.value !== undefined &&
			formData?.mainBranch?.value !== null
		) {
			filter["mainBranch"] = formData?.mainBranch?.value;
		}
		setShouldUpdate((prev) => !prev);
		setFilterParams({ ...filter });
	}, [
		formData?.search,
		formData?.department,
		formData?.type,
		formData?.branch,
		formData?.mainBranch,
	]);

	return (
		<div className="department">
			<Row>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body>
							<input
								type="text"
								value={formData?.search}
								name="search"
								className="custom-input"
								placeholder={Translate[lang].employee_name}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, search: e.target.value }))
								}
							/>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body>
							<ScrollPagination
								Service={branchesService}
								value={formData?.branch}
								nameVal={"name"}
								placeholder={"branch"}
								limit={100}
								setData={(e) =>
									setFormData((prev) => ({ ...prev, branch: e }))
								}
							/>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body>
							<Select
								value={formData?.mainBranch}
								name="mainBranch"
								placeholder={Translate[lang]?.main_branch || "Main Branch"}
								options={[
									{
										label: `${Translate[lang]?.main_branch || "Main Branch"}: ${Translate[lang]?.yes || "Yes"}`,
										value: true,
									},
									{
										label: `${Translate[lang]?.main_branch || "Main Branch"}: ${Translate[lang]?.no || "No"}`,
										value: false,
									},
								]}
								isClearable
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, mainBranch: e }))
								}
							/>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body>
							<ScrollPagination
								Service={new DepartmentService()}
								value={formData?.department}
								nameVal={"name"}
								placeholder={"department"}
								setData={(e) =>
									setFormData((prev) => ({ ...prev, department: e }))
								}
							/>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body>
							<Select
								value={formData?.type}
								name="type"
								placeholder={Translate[lang]?.type}
								options={[
									{
										label: Translate[lang].independent_contractor,
										value: "INDEPENDENT_CONTRACTOR",
									},
								]}
								isClearable
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} className="mb-3">
					<Card>
						<Card.Body className="d-flex gap-8">
							{/* <Button variant="success" className="custom-button">
								{Translate[lang].filter}
							</Button> */}
							<Link to="/employee/add-employee" className="custom-button w-100">
								+ {Translate[lang].add} {Translate[lang].employee}
							</Link>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			{loading && (
				<div style={{ height: "400px" }}>
					<Loader />
				</div>
			)}
			{!loading && hasData === 1 && (
				<Row>
					<Table responsive>
						<thead className="emp-head">
							<tr className="text-center">
								<th>
									<strong>Employee ID</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.name}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.email}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.branch}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.department}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.login_email}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.designation}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.date_of_join}</strong>
								</th>
								<th>
									<strong>{Translate[lang]?.actions}</strong>
								</th>
							</tr>
						</thead>

						<tbody className="table-body">
							{data?.map((item, index) => {
								return (
									<CardItem
										index={index}
										key={index}
										item={item}
										// setResignationModal={setResignationModal}
										setItem={setItem}
										setAddModal={setAddModal}
										setShouldUpdate={setShouldUpdate}
									/>
								);
							})}
						</tbody>
					</Table>
					{/* {data?.map((employee, index) => (
						<Col md={3} key={index} className="mb-3">
							<Card>
								<Card.Body>
									<div className="employee-card">
										<img
											src="https://html.bdevs.net/manez.prev/assets/images/avatar/avatar16.png"
											alt="profile"
											className="profile-img"
											width={100}
											height={100}
										/>
										<p className="employee-name">{employee?.name}</p>
										<p className="employee-job">{employee?.jobTitle}</p>
										<div className="social-icons">
											<div>
												<i className="icon-facebook" />
											</div>
											<div>
												<i className="icon-twitter-x" />
											</div>
											<div>
												<i className="icon-linkedin" />
											</div>
											<div>
												<i className="icon-youtube" />
											</div>
											<div>
												<i className="icon-globe" />
											</div>
										</div>
										<div className="d-flex gap-12 justify-content-center">
											<button>{Translate[lang].call}</button>
											<button>{Translate[lang].view}</button>
										</div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					))} */}
				</Row>
			)}
			{!loading && hasData === 0 && (
				<div className="text-center">
					<NoData />
				</div>
			)}
			<Pagination
				setData={setData}
				service={employeesService}
				shouldUpdate={shouldUpdate}
				setHasData={setHasData}
				setLoading={setLoading}
				search={""}
				param={{ ...filterParams }}
			/>

			{/* {addModal && (
				<AddEmployeeModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					Service={employeesService}
				/>
			)} */}
		</div>
	);
};

export default ActiveEmployees;
